<template>
  <div
    class="tw-group tw-flex tw-items-center"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <i-button
      :type="type"
      :size="size"
      is-icon
      :is-hovering="isHovering"
    >
      <component :is="icon" />
    </i-button>
    <span
      class="tw-ml-4 tw-transition"
      :class="isHovering ? 'tw-text-dark dark:tw-text-dm-dark' : 'tw-text-gray-dark dark:tw-text-dm-gray-dark'"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      isHovering: false,
    };
  },
};
</script>
